const MODAL_CONTROLS_WRAPPER_TARGET_CLASSNAME = 'cctr-js-modal-controls'

const generateModal = ( { state, setState, saveAndCloseModal } ) => {
  const modal = createNode( 'div', ['cctr-modal'] )

  if ( state.config.modalHasBg ) {
    modal.appendChild( modalBg() )
  }

  const toggleModalControls = ( event ) => {
    const controls = document.getElementsByClassName( MODAL_CONTROLS_WRAPPER_TARGET_CLASSNAME )
    const controlsArray = []

    for ( let i = 0, len = controls.length; i < len; i ++ ) {
      controlsArray.push( controls[ i ] )
    }

    controlsArray.forEach( el => {
      if ( el.classList.contains( 'cctr-is-open' ) ) {
        el.classList.remove( 'cctr-is-open' )
        event.target.parentNode.classList.add( 'cctr-is-open' )
      }
      else {
        el.classList.add( 'cctr-is-open' )
        event.target.parentNode.classList.remove( 'cctr-is-open' )
      }

      setFocusableElements( modal, setState )
    } )
  }

  const setAllOptionsAccepted = () => {
    const newOptions = {}

    Object.keys( state.options ).forEach( k => {
      newOptions[ k ] = true
    } )

    setState( 'options', newOptions, false )
  }

  const container = modalContainer( [
    state.config.modalTitle && modalHeader( state.config.modalTitle ),
    modalIntro( state.config.modalIntro ),
    createNode( 'div', ['cctr-is-openable', 'cctr-is-open'], [
      button( {
        buttonText: 'Manage cookies',
        onClick: toggleModalControls,
        buttonType: 'secondary',
      } ),
      button( {
        buttonText: 'Accept cookies',
        onClick: () => {
          setAllOptionsAccepted()
          saveAndCloseModal()
        },
      } ),
    ] ),
    modalControls( [
      ...state.config.options.map( opt => option( {
        ...opt,
        checked: state.options[ opt.name ],
        setCheckboxState: ( value ) => {
          const newOptionsState = state.options
          newOptionsState[ opt.name ] = value
          setState( 'options', newOptionsState, false )
        },
      } ) ),
      button( {
        buttonText: 'Save and close',
        onClick: saveAndCloseModal,
      } ),
    ] ),
  ] )

  container.setAttribute( 'role', 'dialog' )
  container.setAttribute( 'tabIndex', '-1' )
  modal.appendChild( container )

  return modal
}

const option = ( { name, title, description, checked, disabled, setCheckboxState } ) => {
  return createNode( 'div', ['cctr-option'], [
    disabled
      ? createNode( 'h4', ['cctr-checkbox__label'], title )
      : checkbox( { name, label: title, checked, setCheckboxState } ),
    p( description ),
  ] )
}

const checkbox = ( { name, label, checked, setCheckboxState } ) => {
  const checkbox = createNode( 'input', ['cctr-checkbox__input'] )
  checkbox.type = 'checkbox'
  checkbox.name = name
  checkbox.value = 'true'
  checkbox.id = name
  checkbox.checked = checked

  const labelElem = createNode( 'label', ['cctr-checkbox__label'], [
    label,
    checkbox,
  ] )

  const wrapperClassList = ['cctr-checkbox']

  if ( checked ) {
    wrapperClassList.push( 'cctr-checkbox--checked' )
  }

  const wrapper = createNode( 'div', wrapperClassList, labelElem )

  checkbox.onchange = () => {
    setCheckboxState( checkbox.checked )

    if ( checkbox.checked ) {
      wrapper.classList.add( 'cctr-checkbox--checked' )
    }
    else {
      wrapper.classList.remove( 'cctr-checkbox--checked' )
    }
  }

  return wrapper
}

const button = ( { buttonText, buttonType = 'primary', onClick } ) => {
  const button = createNode(
    'button',
    ['cctr-button', `cctr-button--${ buttonType }`],
    buttonText
  )

  button.onclick = onClick
  return button
}

export const modalToggleButton = ( toggleModal ) => {
  const button = createNode(
    'div',
    [`cctr-modal-toggle-button`],
    [
      createNode( 'span', ['cctr-modal-toggle-button__icon'], 'C' ),
      createNode( 'span', ['cctr-modal-toggle-button__text'], 'Cookie settings' ),
    ]
  )

  button.onclick = toggleModal
  return button
}

const _ = undefined
const p = content => createNode( 'p', _, content )
const h4 = content => createNode( 'h4', _, content )

const modalBg = () => createNode( 'div', ['cctr-modal-bg'] )
const modalContainer = content => createNode( 'div', ['cctr-modal-container'], content )
const modalHeader = content => createNode( 'h3', ['cctr-modal-header'], content )
const modalIntro = content => createNode( 'p', ['cctr-modal-intro'], content )
const modalControls = content => createNode(
  'div',
  [
    'cctr-is-openable',
    MODAL_CONTROLS_WRAPPER_TARGET_CLASSNAME
  ],
  content
)

const createNode = ( nodeType, classList = [], content = null ) => {
  const node = document.createElement( nodeType )

  classList.forEach( className => {
    node.classList.add( className )
  } )

  if ( content && !Array.isArray( content ) ) {
    content = [content]
  }

  if ( content ) {
    content.forEach( contentItem => {
      if ( contentItem instanceof HTMLElement ) {
        node.appendChild( contentItem )
      }
      else if ( contentItem ) {
        node.insertAdjacentHTML( 'beforeend', contentItem )
      }
    } )
  }

  return node
}

const setFocusableElements = ( modalElement, setState ) => {
  const elements = modalElement.querySelectorAll(
    `a[href]:not([disabled]),
    button:not([disabled]),
    input[type="checkbox"]:not([disabled])`
  )
  const elementsArray = []

  for ( let i = 0, len = elements.length; i < len; i ++ ) {
    elementsArray.push( elements[ i ] )
  }

  const focusableElements = elementsArray.filter( ( el: HTMLInputElement ) => el.offsetWidth > 0 )
  const firstFocusableElement = focusableElements[ 0 ]
  const lastFocusableElement = focusableElements[ focusableElements.length - 1 ]
  const focusableElementsData = {
    focusableElements,
    firstFocusableElement,
    lastFocusableElement,
  }
  setState( 'focusableElements', focusableElementsData, false )

  return focusableElementsData
}

export const setFocusEvents = ( modalElement, state, setState ) => {
  setFocusableElements( modalElement, setState )

  const { firstFocusableElement } = state.focusableElements
  const KEYCODE_TAB = 9

  firstFocusableElement.focus()

  modalElement.addEventListener( 'keydown', ( e ) => {
    const isTabPressed = ( e.key === 'Tab' || e.keyCode === KEYCODE_TAB )
    const activeElement = <HTMLInputElement>document.activeElement

    if ( !isTabPressed ) {
      return
    }

    const {
      firstFocusableElement,
      lastFocusableElement,
    } = state.focusableElements

    if ( e.shiftKey ) /* shift + tab */ {
      if ( activeElement === firstFocusableElement ) {
        lastFocusableElement.focus()
        e.preventDefault()
      }
    }
    else /* tab */ {
      if ( activeElement === lastFocusableElement ) {
        firstFocusableElement.focus()
        e.preventDefault()
      }
    }
  } )

  modalElement.addEventListener( 'keyup', e => {
    const isTabPressed = ( e.key === 'Tab' || e.keyCode === KEYCODE_TAB )
    const activeElement = <HTMLInputElement>document.activeElement

    if ( !isTabPressed ) {
      return
    }

    const { focusableElements } = state.focusableElements

    const isCheckbox = el => (
      el.nodeName === 'INPUT'
      && el.type === 'checkbox'
    )

    focusableElements.forEach( el => {
      if ( el !== activeElement && isCheckbox( el ) ) {
        el.parentElement.parentElement.classList.remove( 'cctr-has-focus' )
      }
    } )

    if ( isCheckbox( activeElement ) ) {
      activeElement.parentElement.parentElement.classList.add( 'cctr-has-focus' )
    }
  } )
}

export default generateModal
